@if (!isProcessingBySender) {
    <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
        <div fxLayout="column" fxLayoutAlign="start start" class="w-100 bc-mono-white radius-16 p-24">
            <div class="t2-semi-bold">{{ 'i18n_lib_stepperLabel_refundTransaction' | translate }}</div>
            <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
        </div>
        <div class="w-100 bc-mono-white radius-16 p-24 mt-12" fxLayoutAlign="start start">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="w-824">
                <div fxLayout="row" fxLayoutAlign="start center">
                    @if (showDraftButton) {
                        <ui-kit-button spinnerId="submit"
                                       buttonType="button"
                                       (clickListener)="submit()"
                                       [label]="'i18n_af_buttonSaveDraft' | translate"/>
                    }
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="cancel.emit()"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                </div>

                <ui-kit-button type="secondary"
                               (clickListener)="previousStep.emit()"
                               [label]="'i18n_af_buttonBack' | translate"/>
            </div>
        </div>
    </div>
}

@if (isProcessingBySender) {
    <mat-expansion-panel
        [hideToggle]="Spinner.isShown('initForms')"
        [disabled]="Spinner.isShown('initForms')">
        <mat-expansion-panel-header class="w-100"
                                    [class.loading]="Spinner.isShown('initForms')"
                                    fxLayout="start space-between">
            <mat-panel-title class="no-wrap t2-semi-bold">
                {{ 'i18n_lib_stepperLabel_refundTransaction' | translate }}
            </mat-panel-title>
            @if (Spinner.isShown('initForms')) {
                <mat-panel-description fxLayoutAlign="end">
                    <ui-kit-spinner [diameter]="16" [strokeWidth]="3" spinnerIds="initForms"/>
                </mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </mat-expansion-panel>
}

<ng-template #formTemplate>
    @if (form) {
        <form [fxHide]="Spinner.isShown('initForms')" [formGroup]="form" fxLayout="column"
              fxLayoutAlign="start start"
              class="w-100"
              [class.mt-16]="!isProcessingBySender">

            <div class="grid-form-container"
                 [class.mt-24]="!isProcessingBySender">
                @if (form.controls.category && !isProcessingBySender) {
                    <af-dictionary-selector [dictionaryName]="ReferenceBookType.TRANSACTION_CATEGORY"
                                            [control]="form.controls.category"
                                            [predefinedValue]="form.value.category"
                                            [filterDictionaryBy]="filterCategoryBy"
                                            label="i18n_af_labelCategory"
                                            placeholder="i18n_af_placeholderCategory"/>
                }
                @if (form.controls.type && !isProcessingBySender) {
                    <af-dictionary-selector #typeSelector
                                            [dictionary]="filteredTypesList"
                                            [control]="form.controls.type"
                                            [shouldSortDictionary]="true"
                                            [predefinedValue]="form.controls.type.value ?? refund?.transactionType"
                                            label="i18n_af_labelTransactionType"
                                            placeholder="i18n_af_placeholderTransactionType"/>
                }
                @if (form.controls.amount) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div
                            class="t5 c-primary-gray-600">{{ ('i18n_af_labelRefundTransactionAmount') | translate }} {{
                                form.controls.amount.hasValidator(Validators.required) ? '*' : ''
                            }}
                        </div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.controls.amount.value">
                            <input matInput
                                   commonsTiynTengeInput
                                   [formControl]="form.controls.amount"
                                   [placeholder]="'i18n_af_placeholderRefundTransactionAmount' | translate"
                                   name="amount"/>
                            @if (form.controls.amount.hasError('required')) {
                                <mat-error class="c-secondary-red-900 t3">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.currency) {
                    <af-dictionary-selector [dictionaryName]="ReferenceBookType.CURRENCY"
                                            [control]="form.controls.currency"
                                            [predefinedValue]="form.controls?.currency?.value"
                                            label="i18n_af_labelCurrency"
                                            placeholder="i18n_af_placeholderCurrency"/>
                }
                @if (form.controls.amountInKzt) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">
                            {{ ('i18n_af_labelRefundTransactionAmountInKzt') | translate }} {{
                                form.controls.amountInKzt.hasValidator(Validators.required) ? '*' : ''
                            }}
                        </div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.controls.amountInKzt.value">
                            <input matInput
                                   commonsTiynTengeInput
                                   [formControl]="form.controls.amountInKzt"
                                   [placeholder]="'i18n_af_placeholderRefundTransactionAmount' | translate"
                                   name="amount"/>
                            @if (form.controls.amountInKzt.hasError('required')) {
                                <mat-error class="c-secondary-red-900 t3">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }

            </div>
            @if (form.controls.sender) {
                <af-transaction-participant [fxHide]='isProcessingBySender' class="w-100"
                                            [participant]="sender"
                                            mode="refund"
                                            label="i18n_af_labelParticipantSender"
                                            [participantSide]="'sender'"
                                            [form]="form.controls.sender"/>
            }
            @if (form.controls.receiver) {
                <af-transaction-participant [fxHide]='isProcessingBySender' class="w-100"
                                            [participant]="receiver"
                                            mode="refund"
                                            label="i18n_af_labelParticipantReceiver"
                                            [participantSide]="'receiver'"
                                            [form]="form.controls.receiver"/>
            }
        </form>
    }
</ng-template>
